import { useEffect, useState } from "react";
import { FaRegSave } from "react-icons/fa";
import { Oval } from "react-loader-spinner";
import homeStyles from "../../css/home.module.css";
import { getSystemParams } from "../../services/getSystemParams";
import { handleSaveTrial } from "../../services/handleSaveTrial";
import styles from "./css/settingsModal.module.css";


export default function SettingsModal({ isOpen, onClose }) {

    // LOADING CONTROLLER
    const [loading, setLoading] = useState(true);

    // PARAMETROS
    const [trial, setTrial] = useState(0);
    const [editedTrial, setEditedTrial] = useState(false);
    const [loadingSaveTrial, setLoadingSaveTrial] = useState(false);
    const [trialCmv, setTrialCmv] = useState(0);
    const [editedTrialCmv, setEditedTrialCmv] = useState(false);


    useEffect(() => {
        if (!isOpen) return;

        const initModal = async () => {
            try {
                setLoading(true);

                const paramsData = await getSystemParams();

                setTrial(paramsData.trial_time);
                setTrialCmv(paramsData.trial_cmv_time);
                setEditedTrial(false);
                setEditedTrialCmv(false);

            } catch (e) {
                console.error('ERROR - INIT SETTINGS MODAL:', e);

            } finally {
                setLoading(false);
            }
        }

        initModal();

    }, [isOpen]);


    if (!isOpen) return null;

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.modal} onClick={(e) => e.stopPropagation()}>

                {/* HEADER */}
                <div className={styles.header}>
                    <h2 className={styles.title}>Configurações</h2>
                    <button className={styles.closeBtn} onClick={onClose}>✕</button>
                </div>

                {loading ? (
                    <div className={styles.loadingArea}>
                        <Oval visible={true} height="30" width="30" color="#2eb4f1" ariaLabel="oval-loading" />
                    </div>

                ) : (
                    <div className={homeStyles.paramsContainer} style={{ padding: 0 }}>
                        <div className={homeStyles.inputArea} style={{ marginTop: 0 }}>
                            <p className={homeStyles.labelInput}>Dias de trial:</p>
                            <div className={homeStyles.inputContainer}>
                                <input
                                    className={homeStyles.input}
                                    value={trial}
                                    placeholder="dias de teste"
                                    onChange={({ target: { value } }) => {
                                        setTrial(value);
                                        setEditedTrial(true);
                                    }}
                                />

                                {editedTrial ? (
                                    <button className={homeStyles.saveEditButton} onClick={() => handleSaveTrial({ value: trial, setShowButton: setEditedTrial, setLoading: setLoadingSaveTrial, type: 'sofchef' })}>
                                        {loadingSaveTrial ? (
                                            <Oval visible={true} height="15" width="15" color="#ffff" ariaLabel="oval-loading" />
                                        ) : (
                                            <FaRegSave size={15} color={'#fff'} />
                                        )}
                                    </button>
                                ) : null}
                            </div>
                        </div>

                        <div className={homeStyles.inputArea} style={{ marginTop: 0 }}>
                            <p className={homeStyles.labelInput}>Dias de trial (CMV):</p>
                            <div className={homeStyles.inputContainer}>
                                <input
                                    className={homeStyles.input}
                                    value={trialCmv}
                                    placeholder="dias de teste"
                                    onChange={({ target: { value } }) => {
                                        setTrialCmv(value);
                                        setEditedTrialCmv(true);
                                    }}
                                />

                                {editedTrialCmv ? (
                                    <button className={homeStyles.saveEditButton} onClick={() => handleSaveTrial({ value: trialCmv, setShowButton: setEditedTrialCmv, setLoading: setLoadingSaveTrial, type: 'cmv' })}>
                                        {loadingSaveTrial ? (
                                            <Oval visible={true} height="15" width="15" color="#ffff" ariaLabel="oval-loading" />
                                        ) : (
                                            <FaRegSave size={15} color={'#fff'} />
                                        )}
                                    </button>
                                ) : null}
                            </div>
                        </div>
                    </div>
                )}

            </div>
        </div>
    );
}
